import React, { useRef, useEffect } from "react";

export const AutoGrowTextarea = ({ value, minRows = 1, maxHeight = 180, className = "", style, ...props }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = Math.min(el.scrollHeight, maxHeight) + "px";
  }, [value, maxHeight]);
  return (
    <textarea
      ref={ref}
      rows={minRows}
      value={value}
      className={className}
      style={{ overflowY: "auto", resize: "none", ...style }}
      {...props}
    />
  );
};

export default AutoGrowTextarea;
